import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, HelpersService, PermissionsService } from '@base-shared/services';
import { isEmpty, clone, get } from 'lodash';
import { TranslateService } from '@ngx-translate/core';;
import * as moment from 'moment';

@Injectable()
export class BillingGuard implements CanActivate {

  constructor(
    private router: Router,
    private auth: AuthService,
    private helpers: HelpersService,
    private translate: TranslateService,
    private permissions: PermissionsService
  ) { }

  private hadRemaningDays(account: any) {

    const endDate = get(account, 'lockoutDateTimeUtc');
    const daysLeft = get(account, 'daysLeftInTrial') || 0;

    if (!endDate && !daysLeft)
      return true;

    // with negative days on trial
    if (!endDate && (daysLeft <= 0))
      return true;

    if (!endDate)
      return !(daysLeft <= 0);

    const today = moment();
    const diff = moment(endDate).diff(today, 'days');

    return !(diff <= 0);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const currentUser = get(this.auth, 'user') || {};
    const account = currentUser.accounts.find(e => {
      return e.accountId.toString() === this.auth.accountId.toString();
    });

    if (!account)
      return false;

    if (!this.hadRemaningDays(account)) {
      const userType = account.assignedContractTypes.indexOf('reviewer') !== -1 ? 'reviewer'
        : account.assignedContractTypes.indexOf('admin') !== -1 ? 'admin' : 'submitter';

      if (userType === 'reviewer' && this.permissions.checkPermissions(['BILLING', 'BASE'], account.accountPermissions || [])) {
        this.router.navigate(['/billing/lockout/bill']);
        return false;
      }

      this.router.navigate(['/billing/lockout']);
      return false;
    }

    return true;
  }
}
